<div *ngIf="visible">
  <div *ngIf="visible" class="dialog {{enterExitAnimation}} {{ modalSize }}" [ngClass]="{'isSafari': isSafari}">
    <ng-content></ng-content>
    <button *ngIf="closable" (click)="close('button')" aria-label="Close" class="dialog__close-btn"></button>
  </div>
  <div *ngIf="visible" class="oldOverlay overlay {{overlayAnimation}}" (click)="close('overlay')" [ngClass]="{'holdOverlay': holdModalOverlay}"></div>
</div>

